import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicBlogHeader from "../components/PublicBlogHeader";
import { getPublishedBlogPosts } from "../services/blogService";
import "./PublicBlog.css";

function formatDate(value) {
  if (!value) return "";
  const date = value.toDate ? value.toDate() : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(date);
}

export default function PublicBlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "Darssy Blog | Tools and Growth for Tutors and Schools";

    const loadPosts = async () => {
      try {
        setPosts(await getPublishedBlogPosts());
      } catch (err) {
        console.error("Failed to load published blog posts:", err);
        setError("Could not load the blog right now. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    loadPosts();
  }, []);

  return (
    <div className="public-blog-page">
      <PublicBlogHeader />
      <main>
        <section className="public-blog-hero">
          <div className="public-blog-container">
            <div className="public-blog-kicker">Darssy Blog</div>
            <h1>Tools and growth for tutors and schools</h1>
            <p>
              Practical guides for private tutors, tutorial centres, language schools, and teachers
              who want to replace manual admin with a professional teaching system.
            </p>
          </div>
        </section>

        <section className="public-blog-container">
          {loading ? (
            <div className="public-blog-state">Loading articles...</div>
          ) : error ? (
            <div className="public-blog-state public-blog-error">{error}</div>
          ) : posts.length === 0 ? (
            <div className="public-blog-state">
              <div>
                <h2>No published articles yet</h2>
                <p>New Darssy guides will appear here after they are published.</p>
              </div>
            </div>
          ) : (
            <div className="public-blog-grid">
              {posts.map((post) => (
                <article className="public-blog-card" key={post.id}>
                  {post.coverImageUrl && (
                    <img src={post.coverImageUrl} alt={post.title || "Blog cover"} />
                  )}
                  <div className="public-blog-card-body">
                    <div className="public-blog-meta-row">
                      <span className="public-blog-category">{post.category}</span>
                      <span>{formatDate(post.publishedAt)}</span>
                    </div>
                    <h2>
                      <Link to={`/blogs/${post.slug}`}>{post.title}</Link>
                    </h2>
                    <p>{post.excerpt}</p>
                    <Link className="public-blog-read-more" to={`/blogs/${post.slug}`}>
                      Read More
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          )}
        </section>
      </main>
    </div>
  );
}
